import { createSelector } from 'reselect'
import { isEmpty } from 'helpers/utils'

export const getSuggestionsState = state => state.suggestions

export const isFetchingSuggestions = createSelector(
  [getSuggestionsState],
  suggestions => (suggestions ? suggestions.isFetching : false)
)

export const getSuggestionsFrom = createSelector(
  [getSuggestionsState],
  suggestions => (suggestions ? suggestions.suggestionsFrom : null)
)

export const getSuggestionsTo = createSelector(
  [getSuggestionsState],
  suggestions => (suggestions ? suggestions.suggestionsTo : null)
)

export const isFetchingSuggestionsIataCode = createSelector(
  [getSuggestionsState],
  suggestions => (suggestions ? suggestions.isFetchingIataCode : false)
)

export const getSuggestionsFromTo = createSelector(
  [getSuggestionsState],
  suggestions => {
    if (
      !isEmpty(suggestions) &&
      !isEmpty(suggestions.suggestionsTo) &&
      !isEmpty(suggestions.suggestionsFrom)
    ) {
      const { suggestionsTo, suggestionsFrom } = suggestions

      return {
        suggestionsTo: suggestionsTo && suggestionsTo[0][0],
        suggestionsFrom: suggestionsFrom && suggestionsFrom[0][0]
      }
    }

    return []
  }
)
